'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys'),

    ModalMessage  = require('mag-component-modal'),
    LayoutList    = require('mag-component-layout-list'),

    menu = new ModalMessage({
        title: gettext('Actions'),
        visible: false,
        events: {
            show: function () {
                app.activePanelSet.blur();
                this.children[0].focus();
            },
            hide: function () {
                setTimeout(function () {
                    app.activePanelSet.focus();
                }, 0);
            }
        }
    }),

    layoutItems;


if ( TARGET === 'android-stb' ) {
    layoutItems = [
        {
            className: 'title',
            value: gettext('Save new settings')
        }
    ];
} else {
    layoutItems = [
        {
            className: 'theme-icon theme-icon-rc-f1'
        },
        {
            className: 'title',
            value: gettext('Save new settings')
        }
    ];
}


menu.add(new LayoutList({
    className: 'padded',
    size: 1,
    focusIndex: 0,
    data: [
        {
            items: layoutItems,
            click: function () {
                require('./main.panel').save();
                // popup hide
                menu.hide();
            }
        }
    ],
    events: {
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
            if ( event.code === keys.back ) {
                event.stop = true;
                // popup hide
                menu.hide();
            }
        }
    }
}));


module.exports = menu;
